import React, { Component } from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import $ from 'jquery'
/*https://github.com/xiaolin/react-image-gallery*/
import ImageGallery from '../../../Common/ImageGallery';
import EditPic from './edit';
import PicFSUpload from '../../../Common/picFSUpload';
import { dateToString } from '../../../Util/dateTime';
import Waves from 'node-waves';
import {
    onFilesSelected,
    updateDescriptionRequest,
    updatePicRequest,
    setIsShowingDeleteModal,
    attemptDeleteImage,
} from './actions3';
import { Scrollbars } from 'react-custom-scrollbars';
import { semanticColors } from '../../../Globals/styles';
import ConfirmationModal from '../../../Common/confirmationModal';
import auth from '../../../Login/authService'

class Images extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCaroussel: false,
            carousselStartIndex: 0,
            currIndex: 0,
            showEdit: false,
            isDescriptionEdit: false
        }
    }
    componentDidUpdate = () => {
        Waves.attach('.waves-btn', ['waves-button']);
        Waves.attach('.waves-icon', ['waves-circle']);
    };
    componentWillMount = () => {
        const { params, dispatch } = this.props;
    };
    componentWillReceiveProps = (nextProps) => {
        //if a image has just been deleted
        if (nextProps.pics.length < this.props.pics.length) {
            this.setState({
                showCaroussel: false
            })
        }
    };
    render() {
        const { pics, params, dispatch, isShowingDeleteModal } = this.props;

        let token = auth.getToken()
        let _downloadAll = process.env.REACT_APP_webApiEndPoint + "api/file/" + params.workplaceId + "/downloadAll?token=" + token;
        return (
            <div style={styles.body}>
                {isShowingDeleteModal != null ?
                    <ConfirmationModal
                        closeModal={() => dispatch(setIsShowingDeleteModal(null))}
                        onYesMethod={() => dispatch(attemptDeleteImage(this.state.currIndex))}
                        headerText="Slet billede"
                        text={
                            <div>
                                Du er ved at slette billedet.
              <br />Vil du fortsætte?
            </div>}
                    />
                    :
                    null
                }
                {this.state.showCaroussel ?
                    <div style={styles.allContainer}>
                        <ImageGallery
                            showChildren={this.state.showEdit}
                            items={pics}
                            showIndex={true}
                            lazyLoad={true}
                            startIndex={this.state.currIndex}
                            onSlide={(currIndex) => {
                                this.setState({
                                    currIndex: currIndex,
                                    showEdit: false
                                })
                            }}
                            onClose={() => this.setState({ showCaroussel: false, showEdit: false })}
                        >
                            {this.state.showEdit ?
                                <EditPic
                                    pic={pics[this.state.currIndex]}
                                    onSubmit={(editedPic) => {
                                        dispatch(updatePicRequest(editedPic, this.state.currIndex))
                                        this.setState({ showEdit: false })
                                    }
                                    }
                                    onClose={() => { this.setState({ showEdit: false }) }}
                                />
                                : null
                            }
                        </ImageGallery>

                        {this.state.isDescriptionEdit ?
                            <div style={styles.buttonsContainer}>
                                <textarea
                                    style={styles.textArea}
                                    defaultValue={pics[this.state.currIndex].description}
                                    ref="textarea">
                                </textarea>
                                <div className="waves-btn wavesHover"
                                    style={styles.iconsContainer}
                                    onClick={() => {
                                        dispatch(updateDescriptionRequest(
                                            this.state.currIndex,
                                            pics[this.state.currIndex].id,
                                            this.refs.textarea.value));
                                        this.setState({ isDescriptionEdit: false });
                                    }}>
                                    <i
                                        className="fa fa-floppy-o"
                                        aria-hidden="true"
                                        style={styles.icon}
                                    ></i>
                                    <div style={styles.label}>Gem</div>
                                </div>
                                <div style={styles.divider}></div>
                                <div className="waves-btn wavesHover"
                                    style={styles.iconsContainer}
                                    onClick={() => this.setState({ isDescriptionEdit: false })}>
                                    <i
                                        className="fa fa-undo"
                                        aria-hidden="true"
                                        style={styles.icon}
                                    ></i>
                                    <div style={styles.label}>Fortryd</div>
                                </div>
                            </div>
                            :
                            this.state.showEdit ?
                                null
                                :
                                <div style={styles.buttonsContainer}>
                                    <div className="waves-btn wavesHover"
                                        style={styles.iconsContainer}
                                        onClick={() => dispatch(setIsShowingDeleteModal(this.state.currIndex))}>
                                        <i
                                            className="fa fa-trash-o"
                                            aria-hidden="true"
                                            style={styles.icon}
                                        ></i>
                                        <div style={styles.label}>Slet</div>
                                    </div>
                                    <div style={styles.divider}></div>
                                    <div className="waves-btn wavesHover"
                                        style={styles.iconsContainer}
                                        onClick={() => {
                                            this.setState({ isDescriptionEdit: true })
                                            setTimeout(() => { $(this.refs.textarea).focus() }, 300);

                                        }}>
                                        <i
                                            className="fa fa-font"
                                            aria-hidden="true"
                                            style={styles.icon}
                                        ></i>
                                        <div style={styles.label}>Skriv</div>
                                    </div>
                                    <div style={styles.divider}></div>
                                    <div className="waves-btn wavesHover"
                                        style={styles.iconsContainer}
                                        onClick={() => {
                                            this.setState({ showEdit: true })

                                        }}>
                                        <i
                                            className="fa fa-paint-brush"
                                            aria-hidden="true"
                                            style={styles.icon}
                                        ></i>
                                        <div style={styles.label}>Tegn</div>
                                    </div>
                                </div>
                        }

                    </div>
                    :
                    <Scrollbars>
                        <div>
                            <div className="col-xs-3" style={{ 'marginBottom': '24px' }}>
                                <PicFSUpload
                                    className="waves-btn"
                                    style={styles.uploadBtn}
                                    onFilesSelected={files => dispatch(onFilesSelected(files, params.workplaceId))}
                                    multiple={true}>
                                    <div>
                                        <i
                                            className="fa fa-camera fa-2x"
                                            aria-hidden="true"
                                            style={{ 'marginTop': '85px' }}>
                                        </i>
                                        <div
                                            style={{ 'marginTop': '5px' }}>Upload billede
                </div>
                                    </div>
                                </PicFSUpload>
                            </div>
                            {pics.map((pic, i) => {
                                return (
                                    <div
                                        className="col-xs-3"
                                        key={pic.id}
                                        onClick={() => this.setState({
                                            showCaroussel: true,
                                            currIndex: i
                                        })}
                                        style={styles.cardContainer}
                                    >
                                        <div style={styles.innerContainer}>
                                            <div
                                                style={[styles.imgContainer,
                                                { 'backgroundImage': 'url(' + pic.original + ')' }]}>
                                            </div>
                                            <div style={styles.cardBody}>
                                                <div style={styles.date}>{dateToString(new Date(pic.creationDate))}</div>
                                                <div style={styles.description}>
                                                    <div style={styles.descriptionContainer}>
                                                        <span style={styles.descriptionBefore}>...</span>
                                                        {pic.description}
                                                        <span style={styles.descriptionAfter}></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>)
                            })}
                        </div>
                    </Scrollbars>
                }
            </div>
        );
    }
}

var styles = {
    body: {
        height: '100%'
    },
    cardContainer: {
        height: '200px',
        cursor: 'pointer',
        marginBottom: '24px'
    },
    cardBody: {
        width: '100%',
        padding: '0px 12px'
    },
    innerContainer: {
        width: '100%',
        height: '100%',
        borderRadius: '2px',
        backgroundColor: '#fff',
        boxShadow: '0 0px 1px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
    },
    imgContainer: {
        height: '140px',
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        borderTopRightRadius: '2px',
        borderTopLeftRadius: '2px'
    },
    allContainer: {
        height: '100%',
        paddingTop: '70px'
    },
    date: {
        fontWeight: '600',
        fontSize: '12px'
    },
    description: {
        position: 'relative',
        fontSize: '10px',
        width: '100%',
        height: '35px'
    },
    descriptionContainer: {
        position: 'absolute',
        color: semanticColors.text,
        fontSize: '10px',
        top: '10px',
        width: '240px',
        overflow: 'hidden',
        lineHeight: '1.2em',
        maxHeight: '2.4em',
        textAlign: 'left',
        marginRight: '-1em',
        paddingRight: '1em'
    },
    descriptionBefore: {
        position: 'absolute',
        right: '0',
        bottom: '0'
    },
    descriptionAfter: {
        content: '',
        position: 'absolute',
        right: '0',
        width: '1em',
        height: '1em',
        marginTop: '0.2em',
        background: semanticColors.default
    },
    uploadBtn: {
        height: '200px',
        width: '100%',
        textAlign: 'center',
        padding: '0px',
        backgroundColor: '#fff',
        color: 'lightgrey',
        borderRadius: '2px',
        WebkitMaskImage: 'initial'
    },
    textArea: {
        resize: 'none',
        width: '350px',
        height: '50px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset'
    },
    gemBtn: {
        position: 'absolute',
        right: '12px',
        width: '85px',
        top: '92px'
    },
    buttonsContainer: {
        position: 'absolute',
        right: '0',
        top: '130px',
        width: '100%',
    },
    footerBtns: {
        marginLeft: '10px'
    },
    editLabel: {
        display: 'inline-block'
    },
    iconsContainer: {
        textAlign: 'center',
        float: 'right',
        width: '80px',
        height: '50px',
        padding: '5px'
    },
    iconsContainerActive: {
        color: semanticColors.info
    },
    label: {
        fontSize: '12px',
        marginTop: '4px',
        fontWeight: '600'
    },
    icon: {
        display: 'block',
        fontSize: '22px'
    },
    divider: {
        display: 'inline-block',
        float: 'right',
        width: '1px',
        height: '30px',
        marginTop: '10px',
        backgroundColor: semanticColors.mainBackground
    }
}

const selectProps = state => {
    return {
        ...state.dailyReportReducer
    };
}

export default connect(selectProps)(Radium(Images));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Images/index3.js